import LinkFieldWidget from "@/components/EditView/widgets/LinkFieldWidget.vue";
import EmailFieldWidget from "@/components/EditView/widgets/EmailFieldWidget.vue";
import PhoneNumberFieldWidget from "@/components/EditView/widgets/PhoneNumberFieldWidget.vue";
import TextFieldWidget from "@/components/EditView/widgets/TextFieldWidget.vue";
import ClientCache from "@/utils/login/ClientCache.ts";
import FieldType from "@/utils/constants/FieldType.ts";
import DropDownListWidget from "@/components/EditView/widgets/DropDownListWidget.vue";
import ColorFieldWidget from "@/components/EditView/widgets/ColorFieldWidget.vue";
import NumericFieldWidget from "@/components/EditView/widgets/NumericFieldWidget.vue";
import PasswordWidget from "@/components/EditView/widgets/PasswordWidget.vue";
import RichTextEditorWidget from "@/components/EditView/widgets/RichTextEditorWidget.vue";
import BigTextWidget from "@/components/EditView/widgets/BigTextWidget.vue";
import DateFieldWidget from "@/components/EditView/widgets/DateFieldWidget.vue";
import DateAndTimeFieldWidget from "@/components/EditView/widgets/DateAndTimeFieldWidget.vue";
import TimeFieldWidget from "@/components/EditView/widgets/TimeFieldWidget.vue";
import BooleanFieldWidget from "@/components/EditView/widgets/BooleanFieldWidget.vue";
import ReferenceWidget from "@/components/EditView/widgets/ReferenceWidget.vue";
import FileUploaderWidget from "@/components/EditView/widgets/FileUploaderWidget.vue";
import GenericReferenceWidget from "@/components/EditView/widgets/GenericReferenceWidget.vue";
import MapLocationFieldWidget from "@/components/EditView/widgets/MapLocationFieldWidget.vue";
import {WidgetsPresenter} from "@/utils/presenters/interfaces.ts";
import {Component} from "vue";
import HtmlPanelWidget from "@/components/EditView/widgets/HtmlPanelWidget.vue";
import Translator from "@/utils/common/Translator.ts";
import {StringUtils} from "@/utils/common/StringUtils.ts";
import BarcodeTextWidget from "@/components/EditView/widgets/BarcodeTextWidget.vue";
import SQLEditorWidget from "@/components/EditView/widgets/SQLEditorWidget.vue";
import FieldSubType from "@/utils/constants/FieldSubType.ts";
import NamaCommon from "@/utils/common/NamaCommon.ts";
import NamaURLS from "@/utils/constants/NamaURLS.ts";
import {Dialog} from "quasar";
import {useErrorsStore} from "@/stores/ToastDataStore.ts";
import ReferenceFieldWidgetUtil from "@/utils/editView/widgets/ReferenceFieldWidgetUtil.ts";
import ReferenceGridFieldWidgetUtil from "@/utils/editView/widgets/ReferenceGridFieldWidgetUtil.ts";
import ReferenceDialog from "@/components/dialogs/ReferenceDialog.vue";
import XMLEditorWidget from "@/components/EditView/widgets/XMLEditorWidget.vue";
import TempoEditorWidget from "@/components/EditView/widgets/TempoEditorWidget.vue";
import ObjectChecker from "@/utils/common/ObjectChecker.ts";
import SoundEffectWidget from "@/components/EditView/widgets/SoundEffectWidget.vue";
import FieldMetaData = namaTypes.FieldMetaData;
import BasicFieldMetaData = namaTypes.BasicFieldMetaData;
import FieldActionContextInfo = namaTypes.FieldActionContextInfo;
import EntityReferenceData = namaTypes.EntityReferenceData;
import GCFailure = namaTypes.GCFailure;
import DTOGui2Response = namaTypes.DTOGui2Response;

export default class EditScreenFieldUtils {
  static createField(presenter: WidgetsPresenter, fieldMetaData: FieldMetaData | BasicFieldMetaData): Component | undefined {
    switch (fieldMetaData.fieldType) {
      case FieldType.Color:
        if (ClientCache.isFieldValuesRestricted(presenter.entityType, fieldMetaData.fieldId))
          return EditScreenFieldUtils.createComboForTextField(fieldMetaData, presenter.entityType);
        else if (ClientCache.isNotColorField(presenter.entityType, fieldMetaData.fieldId))
          return EditScreenFieldUtils.createTextField(fieldMetaData, presenter);
        else
          return ColorFieldWidget;
      case FieldType.PhoneNumber:
        if (ClientCache.isFieldValuesRestricted(presenter.entityType, fieldMetaData.fieldId))
          return EditScreenFieldUtils.createComboForTextField(fieldMetaData, presenter.entityType);
        else
          return PhoneNumberFieldWidget;
      case FieldType.Link:
        if (ClientCache.isFieldValuesRestricted(presenter.entityType, fieldMetaData.fieldId))
          return EditScreenFieldUtils.createComboForTextField(fieldMetaData, presenter.entityType);
        else
          return LinkFieldWidget;
      case FieldType.Email:
        if (ClientCache.isFieldValuesRestricted(presenter.entityType, fieldMetaData.fieldId))
          return EditScreenFieldUtils.createComboForTextField(fieldMetaData, presenter.entityType);
        else
          return EmailFieldWidget;
      case FieldType.Text:
      case FieldType.FieldID:
        if (ClientCache.isFieldValuesRestricted(presenter.entityType, fieldMetaData.fieldId))
          return EditScreenFieldUtils.createComboForTextField(fieldMetaData, presenter.entityType);
        else
          return EditScreenFieldUtils.createTextField(fieldMetaData, presenter);
      case FieldType.Decimal:
      case FieldType.Integer:
      case FieldType.Long:
        return NumericFieldWidget;
      case FieldType.Password:
        if (ClientCache.isFieldValuesRestricted(presenter.entityType, fieldMetaData.fieldId))
          return EditScreenFieldUtils.createComboForTextField(fieldMetaData, presenter.entityType);
        else
          return PasswordWidget;
      case FieldType.BigText:
        if (ClientCache.doesFieldHaveAllowedValues(presenter.entityType, fieldMetaData.fieldId))
          return EditScreenFieldUtils.createTextField(fieldMetaData, presenter);
        else if ((!fieldMetaData['forCriteria'] && ClientCache.isRichTextField(presenter.entityType, fieldMetaData.fieldId)) || fieldMetaData.richText)
          return RichTextEditorWidget;
        else if (ClientCache.isBarcodeTextField(fieldMetaData.fieldId))
          return BarcodeTextWidget;
        else if (this.supportSQLEditor(fieldMetaData))
          return SQLEditorWidget;
        else if (this.supportXmlEditor(fieldMetaData))
          return XMLEditorWidget;
        else if (this.supportTempoEditor(fieldMetaData))
          return TempoEditorWidget;
        else
          return BigTextWidget
      case FieldType.Date:
        return DateFieldWidget;
      case FieldType.DateAndTime:
        return DateAndTimeFieldWidget;
      case FieldType.Time:
        return TimeFieldWidget;
      case FieldType.Boolean:
        return BooleanFieldWidget;
      case FieldType.Enum:
      case FieldType.EntityType:
      case FieldType.FeatureID:
        if (ClientCache.isSoundEffectField(fieldMetaData.fieldId))
          return SoundEffectWidget;
        return DropDownListWidget;
      case FieldType.Reference:
        return ReferenceWidget;
      case FieldType.Binary:
        return FileUploaderWidget;
      case FieldType.Genericreference:
        return GenericReferenceWidget;
      case FieldType.LatLng:
        return MapLocationFieldWidget;
    case "HtmlPanel":
        return HtmlPanelWidget;
      case "SoundEffect":
        return SoundEffectWidget;
    }
  }

  static createTextField(fieldMetadata: FieldMetaData, accessor: any): Component {
    if (ClientCache.isTextToLink(accessor, fieldMetadata.fieldId!) || fieldMetadata.fieldType == FieldType.Link)
      return LinkFieldWidget;
    else if (ClientCache.isTextToEmail(accessor, fieldMetadata.fieldId!) || fieldMetadata.fieldType == FieldType.Email)
      return EmailFieldWidget;
    else if (ClientCache.isTextToPhoneNumber(accessor, fieldMetadata.fieldId!) || fieldMetadata.fieldType == FieldType.PhoneNumber)
      return PhoneNumberFieldWidget;
    return TextFieldWidget;
  }

  static createComboForTextField(fieldMetaData: FieldMetaData, ownerId: string): Component {
    fieldMetaData.allowedValues = ClientCache.getAllowedValuesFor(ownerId, fieldMetaData.fieldId!);
    return DropDownListWidget;
  }

  static fetchSearchTextForAllowedValue(value: string, enumTypeName?: string) {
    let ar = Translator.isArabic() ? Translator.translate(value, enumTypeName)! : Translator.translateInOtherLang(value, enumTypeName)!;
    let en = !Translator.isArabic() ? Translator.translate(value, enumTypeName)! : Translator.translateInOtherLang(value, enumTypeName)!;
    let searchData = value.toLowerCase() + " " + ar.toLowerCase() + " " + StringUtils.normalizeArabic(ar.toLowerCase()) + " " +
      en.toLowerCase();
    if (enumTypeName === 'EntityTypeDF' || enumTypeName === 'DocumentEntityTypeDF' || enumTypeName === 'MasterEntityTypeDF')
      searchData += " " + Translator.translateIdAr(value + "s")!.toLowerCase() + " " +
        StringUtils.normalizeArabic(Translator.translateIdAr(value + "s")!.toLowerCase()) + " " +
        Translator.translateIdEn(value + "s")!.toLowerCase();
    return searchData;
  }

  static async findRefByCode(entityType: string, code: string, searchContextInfo?: FieldActionContextInfo, fieldUtil?: ReferenceFieldWidgetUtil | ReferenceGridFieldWidgetUtil) {
    if (!code)
      return undefined;
    let result = await NamaCommon.namaFetch(NamaURLS.FIND_REF_BY_CODE, {
      params: {
        entityType: entityType,
        code: code,
      },
      data: searchContextInfo,
      doNotPushErrorWhenFailure: true
    });
    if (NamaCommon.isSuccess(result))
      return result as EntityReferenceData;
    if (ClientCache.isOpenCreate(searchContextInfo?.sourceEntityType, searchContextInfo?.sourceFieldId)) {
      let path = ClientCache.fetchFieldToSetValueInForOpenCreate(searchContextInfo?.sourceEntityType, searchContextInfo?.sourceFieldId);
      const result = await NamaCommon.namaFetch(NamaURLS.CREATE_NEW, {
        params: {
          entityType
        },
        data: {
          context: searchContextInfo
        }
      });
      let newObject: Record<string, any> | undefined = {};
      if (NamaCommon.isSuccess(result))
         newObject = (result as DTOGui2Response).data;
      if (ObjectChecker.isEmptyOrNull(path))
        path = "code";
      NamaCommon.setFieldValue(newObject, path, code)
      Dialog.create({
        component: ReferenceDialog,
        componentProps: {
          fieldUtil,
          isInNewMode: true,
          newObject
        }
      })
    }
    else
      useErrorsStore().pushErrors((result as GCFailure).errors as namaTypes.NaMaError[]);
  }

  static supportSQLEditor(fieldMetaData: FieldMetaData): boolean {
    return fieldMetaData.fieldSubType == FieldSubType.SqlQuery;
  }

  static supportXmlEditor(fieldMetaData: FieldMetaData) {
    return fieldMetaData.fieldSubType === FieldSubType.Xml;
  }

  static supportTempoEditor(fieldMetaData: FieldMetaData) {
    return fieldMetaData.fieldSubType === FieldSubType.TempoTemplate;
  }
}
